/** The Landed card from any screen (components/Landed.tsx; core landed.ts): fills in the viewer's role and the shared-tablet flag. */
import { useCallback } from "react";
import type { LandedEvent } from "@logwave/core";
import { useToast, type LandedOpts } from "../components/ui.tsx";
import { useSessionMaybe } from "../session.tsx";
import { useKiosk } from "./kiosk.ts";

/** Show a Landed card for a save, with this viewer's role and whether this is the shared tablet (no names, no peek). */
export function useLanded(): (e: LandedEvent, opts?: LandedOpts) => void {
  const toast = useToast();
  // Outside a session (a component tested alone) the viewer is the most limited one: staff, so never a wider peek.
  const role = useSessionMaybe()?.role ?? "staff";
  const kiosk = !!useKiosk();
  return useCallback((e, opts) => toast.landed(e, { role, kiosk }, opts), [toast, role, kiosk]);
}
